module.exports = __webpack_public_path__ + "img/V-63-ER-1000-GA.db0e3803.png";